function Tabs({ tabs, selectedTab, onTabSet }) {
  return (
    <div className="flex shrink-0 gap-1 border-b border-border bg-muted/40 p-1">
      {tabs.map((tab) => {
        const isDisabled = tab.disabled;
        return (
          <button
            key={tab.name}
            onClick={() => !isDisabled && onTabSet(tab.name)}
            disabled={isDisabled}
            className={`flex-1 rounded-lg py-2 text-sm font-medium capitalize transition ${
              selectedTab === tab.name
                ? 'bg-background text-primary shadow-sm'
                : isDisabled
                ? 'text-muted-foreground/50 cursor-not-allowed'
                : 'text-muted-foreground'
            }`}
          >
            {tab.name}
          </button>
        );
      })}
    </div>
  );
}

export default Tabs;
